// extracted by mini-css-extract-plugin
export default {"wrapper":"Info_wrapper__f5tbm","title":"Info_title__Gbzve","content":"Info_content__4vmWC"};